module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.574fd0b5.woff2";